export default {
    commenting: 'دیدگاه‌ها',
};
